import Dialog from '@mui/material/Dialog';
import { styled } from '@mui/material/styles';

export const BaseDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(1),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
  '& .MuiDialog-paper': {
    maxWidth: '100vw',
    maxHeight: '100%',
    width: '100vw',
    height: '92%',
    borderRadius: '20px',
  },
}));